import { useBehavior, useTriggerAction } from '@libs/hooks';
import { ActionActionTypeEnum, TWidgetProps } from '@libs/types';
import React from 'react';
import { TCoreTextData } from '../types/data';
import { TCoreTextOptions } from '../types/options';
import { CoreTextView } from './CoreTextView';

/**
 * Standalone text widget driven entirely by server-provided configuration.
 * Owns behavior hooks (useBehavior, useTriggerAction) and delegates rendering to CoreTextView.
 *
 * Use this component when the widget definition comes from the server and no
 * additional style overrides are required.
 */
const CoreTextWidget = ({ widget }: TWidgetProps<TCoreTextData, TCoreTextOptions>) => {
    const { isHidden, isDisabled } = useBehavior(widget);
    const { triggerActionsByNameAndType } = useTriggerAction(widget);

    const onClickAction = (actionName: string) => {
        if (actionName) {
            triggerActionsByNameAndType(ActionActionTypeEnum.onClick, actionName).then();
        }
    };

    return (
        <CoreTextView
            widget={widget}
            isHide={isHidden}
            isDisabled={isDisabled}
            text={widget.data?.text}
            styleName={widget.options?.style}
            onClickAction={onClickAction}
        />
    );
};

export { CoreTextWidget };
